import React from 'react';

const Loader = props => {
    return <div className="loader-wrapper">
        <div className="loader">
            <span></span>
            <span></span>
            <span></span>
        </div>

        <div className="message">
            {this && this.props.message}
        </div>
    </div>
}

export default Loader
